export default "__VITE_ASSET__d77b6113__"